import { FC, useCallback, useEffect, useState } from "react";
import IFormUtenteProps from "pages/Prenotazione/Form/Assistito/FormUtente/IFormUtenteProps";
import { GeneralRepository } from "core/data/index";
import { IOption } from "core/interfaces/data/IOption";

import { DatePicker, Input, Radio, Space, Form, Switch, FormInstance, Spin } from "antd";
import { HrText, CustomRadio, CustomButton, RemoteSelect, Label } from "core/interfaces/components/index";

import {
	validateCf,
	validatePhoneNumber,
	validateEmailLogin,
	validateNotExixtsLogInCf,
	validateNotExixtsPersRifCf,
	validateExixtsAssistedCf,
	validateCfVsFormData,
} from "utils/Validate";
import { getDatiUtenteFromCF } from "utils/Helper";

import "./FormUtente.css";
import moment, { Moment } from "moment";
import { FaChevronLeft } from "react-icons/fa";
import { ICittadinanza, IComune } from "core/interfaces/data/IGeneralRequest";
import PasswordForm from "components/PasswordForm/PasswordForm";

import _ from "lodash";
import { notifyValidationError } from "components/NotificaValidazioneFallita/NotificaValidazioneFallita";
import { IRegisterData } from "core/interfaces/data/IRegisterRequest";
import React from "react";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import { IValidateCfVsFormData } from "core/interfaces/util/IValidators";
import { Enhanced } from "utils/ReactUtils";
import dayjs, { Dayjs } from "dayjs";

interface IRegisterFormData extends Omit<IRegisterData, "ComuneNascita" | "DataNascita" | "Cittadinanza"> {
	ComuneNascita: IOption;
	DataNascita: Moment|Dayjs;
	CodiceCittadinanza: IOption;
	ConfirmPassword: string;
}

const FormUtente: FC<IFormUtenteProps> = ({ OnSubmit, ChangeAuthenticationMode, t, i18n, dataForm }) => {
	const [perFamiliare, setPerFamiliare] = useState<string | undefined>(undefined);
	const [comune, setComune] = useState<IOption>();
	const formRef = React.createRef<FormInstance>();

	const registerData = dataForm.registerData;
	const [spinning, setSpinning] = useState<boolean>(false);
	const [cittadinanza, setCittadinanza] = useState<IOption>();
	const [isFirstLoad, setIsFirstLoad] = useState<boolean>(true);
	const [mail, setMail] = useState<string>();

	const getCittadinanze = async (cittadinanza: string): Promise<ICittadinanza[] | undefined> => {
		const cittadinanzeFetched = await GeneralRepository.getCittadinanze({
			Descrizione: cittadinanza,
			culture: i18n.language,
		});

		return cittadinanzeFetched;
	};

	const fetchCittadinanze = async (cittadinanza: string): Promise<IOption[]> => {
		if (!cittadinanza.isNullOrWhiteSpaces()) {
			const cittadinanze = await getCittadinanze(cittadinanza);

			if (cittadinanze) {
				return cittadinanze.map((cittadinanza, index) => mapCittadinanza(cittadinanza));
			}
		}

		return [];
	};

	const mapCittadinanza = (cittadinanza: ICittadinanza) => {
		return { label: cittadinanza.Descrizione, value: cittadinanza.ID, key: cittadinanza.Code };
	};

	const OnChangePerFamiliare = (e: any) => {
		if (e.target.value) {
			setPerFamiliare(t("register.form.assistance.familiare.title"));
		} else {
			setPerFamiliare(t("register.form.assistance.me.title"));
		}
	};

	const comuneOption = useCallback(
		(comune: IComune, index: number): IOption => {
			var labelComune = `${comune.Descrizione} (${comune.Provincia})`;
			if (!comune.IsValid) labelComune += t("register.comuneSoppresso");

			let res: IOption = { label: labelComune, value: comune.CodIstat, key: index };
			return res;
		},
		[t]
	);

	const fetchComuni = async (comune: string): Promise<IOption[]> => {
		const comuni = await GeneralRepository.getComuni({
			Comune: comune,
			culture: i18n.language,
			Validi: false,
		});

		if (comuni) {
			return comuni?.map((comune, index) => comuneOption(comune, index));
		}

		return [];
	};

	const OnSubmitForm = async (data: IRegisterFormData) => {
		const comuneNascitaSelected: IOption = data.ComuneNascita;

		const comuni = await GeneralRepository.getComuni({
			Comune: comuneNascitaSelected.label.substring(0, comuneNascitaSelected.label.indexOf(" (")),
			culture: i18n.language,
			Validi: false,
		});

		if (comuni && data.CodiceCittadinanza.key) {
			let comuneSelected = comuni.filter((comune) => comune.CodIstat === comuneNascitaSelected.value)[0];
			var cittadinanzaSelected = await getCittadinanze(data.CodiceCittadinanza.key.toString());

			if (comuneSelected && cittadinanzaSelected) {
				let resdata: IRegisterData = {
					Nome: data.Nome,
					Cognome: data.Cognome,
					CodiceFiscale: data.CodiceFiscale,
					TelefonoContatti: data.TelefonoContatti,

					Email: data.Email,
					Password: data.Password,
					Sesso: data.Sesso,
					ComuneNascita: comuneSelected,
					DataNascita: data.DataNascita.toDate(),
					PerFamiliare: data.PerFamiliare,
					ConsensoSMS: data.ConsensoSMS ?? false,
					ConsensoMail: data.ConsensoMail,
					Cittadinanza: cittadinanzaSelected[0],
				};

				OnSubmit(resdata);
			}
		}
		setSpinning(false);
	};

	const OnFinishFailed = (e: any) => {
		const input = document.querySelector(`#${e.errorFields[0].name[0]}`);

		if (input) {
			input.scrollIntoView({
				behavior: "smooth",
				block: "center",
				inline: "center",
			});
		}

		const errors = e.errorFields;

		let notifica = {
			Title: t("register.requiredMessages.notifica.titolo"),
			Message: new Array<string>(),
		};
		_.each(errors, (err, index: number) => {
			notifica.Message.push(t("register.requiredMessages.notifica." + err.name[0]));
		});

		setSpinning(false);
		notifyValidationError(notifica.Title, notifica.Message);
	};

	const OnChangeCodiceFiscale = async (props: any) => {
		let cf = props.target.value;

		let res = await getDatiUtenteFromCF(cf);

		if (res) {
			var cittadinanza: IOption | undefined = undefined;
			if (res && res?.cittadinanza) {
				cittadinanza = mapCittadinanza(res.cittadinanza);
			}

			if (res?.comune) fetchComuni(res?.comune?.Descrizione);
			formRef.current!.setFieldsValue({
				Sesso: res.sesso,
				DataNascita: res?.dataNascita!==undefined ? dayjs(res?.dataNascita) : undefined,
				// DataNascita: moment(res.dataNascita, "DD/MM/YYY", true),
				ComuneNascita: res && res?.comune ? comuneOption(res?.comune, res?.comune.ID) : undefined,
				CodiceCittadinanza: cittadinanza,
			});

			setComune(res && res?.comune ? comuneOption(res?.comune, res?.comune.ID) : undefined);
			setCittadinanza(cittadinanza);
		}
	};

	useEffect(() => {
		if (isFirstLoad && registerData) {
			var comNascita = comuneOption(registerData.ComuneNascita, registerData.ComuneNascita.ID);
			var cittadinanza = mapCittadinanza(registerData.Cittadinanza);
			setComune(comNascita);
			setCittadinanza(cittadinanza);

			var fromData: IRegisterFormData = {
				DataNascita: dayjs(registerData?.DataNascita),// registerData?.DataNascita.toMonentWS(),
				CodiceCittadinanza: cittadinanza,
				ComuneNascita: comNascita,
				CodiceFiscale: registerData.CodiceFiscale,
				Cognome: registerData.Cognome,
				Nome: registerData.Nome,
				Email: registerData.Email,
				PerFamiliare: registerData.PerFamiliare,
				Sesso: registerData.Sesso,
				ConsensoMail: registerData.ConsensoMail,
				ConsensoSMS: registerData.ConsensoSMS ?? false,
				TelefonoContatti: registerData.TelefonoContatti,
				Password: registerData.Password,
				ConfirmPassword: registerData.Password,
			};
			formRef.current!.setFieldsValue(fromData);
			setIsFirstLoad(false);
		}
	}, [comuneOption, registerData, formRef, isFirstLoad]);

	const getFormForCfvalidation = (): IValidateCfVsFormData => {
		var comuneNascita = formRef.current?.getFieldValue("ComuneNascita") as IOption;

		var res: IValidateCfVsFormData = {
			Nome: formRef.current?.getFieldValue("Nome"),
			Cognome: formRef.current?.getFieldValue("Cognome"),
			DataNascita: formRef.current?.getFieldValue("DataNascita"),
			IstatComuneNascita: comuneNascita?.value.toString(),
			ComuneNascita: comuneNascita?.label?.split("(")[0]?.trimEnd(),
			Sesso: formRef.current?.getFieldValue("Sesso"),
		};

		return res;
	};

	return (
		<div id="register">
			<div className="title">
				<span>{t("register.title")}</span>
			</div>
			<CustomButton
				text={t("register.backTologin")}
				style={{ width: "100%", marginBottom: "3%" }}
				OnClick={ChangeAuthenticationMode}
				icon={<FaChevronLeft />}
				buttonType={CustomButtonType.positive}
			/>
			<Spin spinning={spinning}>
				<HrText text={t("register.datiUtente")} />
				<Form onFinishFailed={OnFinishFailed} onFinish={OnSubmitForm} ref={formRef}>
					<div>
						<Label text={t("register.form.name.name")} />
						<div>
							<Form.Item name="Nome" rules={[{ required: true, message: t("register.requiredMessages.name") }]}>
								<Input placeholder={t("register.form.name.placeholder")} size="large" />
							</Form.Item>
						</div>
					</div>
					<div>
						<Label text={t("register.form.surname.name")} />
						<div>
							<Form.Item name="Cognome" rules={[{ required: true, message: t("register.requiredMessages.surname") }]}>
								<Input placeholder={t("register.form.surname.placeholder")} size="large" />
							</Form.Item>
						</div>
					</div>
					<div>
						<Label text={t("register.form.cf.name")} />
						<div>
							<Form.Item
								name="CodiceFiscale"
								normalize={(props) => props.toUpperCase()}
								rules={[
									{ required: true, message: t("register.requiredMessages.cf") },
									{ validator: (rule: any, value: any, callback: any) => validateCf(rule, value, callback, t("register.validationMessages.cf")) },
									{
										validator: (rule: any, value: any, callback: any) =>
											validateNotExixtsLogInCf(rule, value, callback, t("register.validationMessages.cfLoginExists")),
									},
									{
										validator: (rule: any, value: any, callback: any) =>
											validateNotExixtsPersRifCf(
												rule,
												value,
												callback,
												t("register.validationMessages.cfPersRifExists").format(window.CONFIG.REACT_APP_CONTATTI.TELEFONO)
											),
									},
									{
										validator: (rule: any, value: any, callback: any) =>
											validateExixtsAssistedCf(
												rule,
												value,
												callback,
												t("register.validationMessages.cfFamiliareExists").format(window.CONFIG.REACT_APP_CONTATTI.TELEFONO)
											),
									},
									{
										validator: (rule: any, value: any, callback: any) =>
											validateCfVsFormData(
												rule,
												value,
												callback,
												t("register.validationMessages.cfNotCorresponding").format(window.CONFIG.REACT_APP_CONTATTI.TELEFONO),
												getFormForCfvalidation()
											),
									},
								]}
							>
								<Input maxLength={16} placeholder={t("register.form.cf.placeholder")} size="large" onChange={OnChangeCodiceFiscale} />
							</Form.Item>
						</div>
					</div>
					<div>
						<Label text={t("register.form.phone.name")} />
						<div>
							<Form.Item
								name="TelefonoContatti"
								rules={[
									{ required: true, message: t("register.requiredMessages.phone") },
									{
										validator: (rule: any, value: any, callback: any) =>
											validatePhoneNumber(rule, value, callback, t("register.validationMessages.phone")),
									},
								]}
							>
								<Input type="tel" prefix="+39" minLength={8} maxLength={10} placeholder={t("register.form.phone.placeholder")} size="large" />
							</Form.Item>
						</div>
					</div>
					<HrText text={t("register.login")} />
					<div className="loginData">
						<div>
							<Label text={t("register.form.email")} />
							<div>
								<Form.Item
									name="Email"
									rules={[
										{ required: true, message: t("login.messagges.username") },
										{
											validator: (rule: any, value: any, callback: any) =>
												validateEmailLogin(rule, value, callback, t("register.validationMessages.email")),
										},
									]}
								>
									<Input type="text" size="large" onChange={(e) => setMail(e.target.value)} />
								</Form.Item>
							</div>
						</div>
						<PasswordForm mail={mail} />
					</div>
					<HrText text={t("register.datiPersonali")} />
					<div>
						<Label text={t("register.form.sesso.name")} />
						<div>
							<Form.Item name="Sesso" rules={[{ required: true, message: t("register.requiredMessages.sex") }]}>
								<Radio.Group>
									<Space direction="vertical">
										<CustomRadio text={t("register.form.sesso.male")} value="M" />
										<CustomRadio text={t("register.form.sesso.female")} value="F" />
									</Space>
								</Radio.Group>
							</Form.Item>
						</div>
					</div>
					<div>
						<Label text={t("register.form.birthday.name")} />
						<div>
							<Form.Item name="DataNascita" rules={[{ required: true, message: t("register.requiredMessages.birthday"), type: "date" }]}>
								<DatePicker /*ref={dateRef}  onKeyDown={onKeyDown}*/
									disabledDate={(current) => current && current > moment()}
									format="DD/MM/YYYY"
									style={{ width: "100%" }}
									placeholder=""
								/>
							</Form.Item>
						</div>
					</div>
					<div>
						<Label text={t("register.form.municipality.name")} />
						<div>
							<Form.Item name="ComuneNascita" rules={[{ required: true, message: t("register.requiredMessages.municipality") }]}>
								<RemoteSelect
									allowClear
									placeholder={t("register.form.municipality.placeholder")}
									debounceTimeout={20}
									fetchOptions={fetchComuni}
									value={comune?.value}
									searchValue={comune?.label}
									OnClear={() => {
										setComune(undefined);
										formRef.current!.setFieldsValue({
											ComuneNascita: undefined,
										});
									}}
									OnChange={(newValue, Option: any) => {
										formRef.current!.setFieldsValue({
											ComuneNascita: Option,
										});
										setComune(Option as IOption);
									}}
								/>
							</Form.Item>
						</div>
					</div>

					<div>
						<Label text={" *" + t("assistito.form.nationality.name")} />
						<Form.Item name="CodiceCittadinanza" rules={[{ required: true, message: t("assistito.requiredMessages.nationality") }]}>
							<RemoteSelect
								allowClear
								placeholder={t("assistito.form.nationality.placeholder")}
								debounceTimeout={10}
								fetchOptions={fetchCittadinanze}
								value={cittadinanza?.value}
								searchValue={cittadinanza?.label}
								OnClear={() => {
									setCittadinanza(undefined);
									formRef.current!.setFieldsValue({
										CodiceCittadinanza: undefined,
									});
								}}
								OnChange={(newValue, option: any) => {
									formRef.current!.setFieldsValue({
										CodiceCittadinanza: option,
									});
									setCittadinanza(cittadinanza);
								}}
							/>
						</Form.Item>
					</div>

					<div className="assistenza">
						<Form.Item name="PerFamiliare" rules={[{ required: true, message: t("register.requiredMessages.assistance") }]}>
							<Radio.Group buttonStyle="solid" onChange={OnChangePerFamiliare}>
								<Radio.Button value={true}>{t("register.form.assistance.familiare.title")}</Radio.Button>
								<Radio.Button value={false}>{t("register.form.assistance.me.title")}</Radio.Button>
							</Radio.Group>
						</Form.Item>
						<div>
							{perFamiliare && (
								<>
									<span className="text title-assistenza">{perFamiliare}</span>
									{perFamiliare === t("register.form.assistance.familiare.title") ? (
										<span className="text subtitle-assistenza">{t("register.form.assistance.familiare.subtitle")}</span>
									) : (
										<span className="text subtitle-assistenza">{t("register.form.assistance.me.subtitle")}</span>
									)}
								</>
							)}
						</div>
					</div>

					<HrText text={t("register.notifiche")} />
					<div className="consensi">
						<div className="switch-button">
							{window.CONFIG.REACT_APP_CONSENSI.SMS.ENABLED && (
								<>
									<div>
										<span className="text-cb">{t("register.form.receiveSms")}</span>
									</div>
									<Form.Item name="ConsensoSMS" initialValue={false} valuePropName="checked" style={{ marginBottom: 0 }}>
										<Switch className="toggle"/>
									</Form.Item>
								</>
							)}
						</div>
						<div className="switch-button">
							<div>
								<span className="text-cb">{t("register.form.receiveMail")}</span>
							</div>
							<Form.Item name="ConsensoMail" initialValue={true} valuePropName="checked" style={{ marginBottom: 0 }}>
								<Switch className="toggle"/>
							</Form.Item>
						</div>
					</div>
					<div>
						<CustomButton
							text={t("register.registraFamiliare")}
							style={{ width: "100%" }}
							htmlType="submit"
							OnClick={() => {
								setSpinning(true);
							}}
							buttonType={CustomButtonType.positive}
						/>
					</div>
				</Form>
			</Spin>
		</div>
	);
};

export default  Enhanced( FormUtente,{componentNamespace:"FormUtente"});
